module.exports = __webpack_public_path__ + "img/星链数据柔性供应链.0785b131.png";